module.exports = __webpack_public_path__ + "static/media/contact.f3eca15f.jpg";